<template>
  <div
    class="date-time container my-auto"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    "
  >
    <div class="timer-group">
      <span class="symbol material-symbols-outlined mx-1">schedule</span>
      <span class="text mx-1">{{ timeStr }}</span>
    </div>

    <div class="timer-group">
      <span class="symbol my-auto material-symbols-outlined mx-1">today</span>
      <span class="text mx-1">{{ dateStr }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateTime",
  data() {
    return {
      timeStr: "",
      dateStr: "",
      dateTimeCount: null,
      timeZone: "America/New_York", // Set your desired timezone here
    };
  },
  methods: {
    setDate() {
      const now = new Date();

      // Format date and time based on the selected timezone
      const options = {
        timeZone: this.timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      // Get formatted date and time
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // Extract and assign date and time
      const dateParts = parts.filter((part) => ["month", "day", "year"].includes(part.type));
      const timeParts = parts.filter((part) => ["hour", "minute", "second"].includes(part.type));

      this.dateStr = dateParts.map((part) => part.value).join("/");
      this.timeStr = timeParts.map((part) => part.value).join(";");
    },
  },
  mounted() {
    this.dateTimeCount = setInterval(this.setDate, 1000);
  },
  beforeUnmount() {
    clearInterval(this.dateTimeCount);
  },
};
</script>

<style scoped>
.timer-group {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text {
  font-size: 1.5vw;
  font-family: "Egoistism";
  font-style: italic;
}
.symbol {
  font-size: 2vw;
}
</style>